import axios from "axios";

export const repertorizarAntihomotoxicos = async (codigos) => {
  const { data } = await axios.get("/api/repertorizacion/antihomotoxicos/", {
    params: {
      codigos,
    },
  });
  return data;
};
